import React, {useEffect} from 'react';
import {useOktaAuth, Security} from '@okta/okta-react';
import config from "./shared/config";
import App from "./App";
export default function SecureApp() {
    return (
        <Security {...config}>
            <App></App>
        </Security>
    );
}